import { type ModelDocumentData, type ModelDocumentFieldValue } from "@doitintl/models-types";

export type DocumentFieldValue = ModelDocumentFieldValue;

export type DocumentData = ModelDocumentData;

export class FieldValue<TElements = any> {
  constructor(
    readonly methodName: string,
    readonly elements?: TElements
  ) {}

  isEqual(other: FieldValue): boolean {
    return this.methodName === other.methodName;
  }

  static delete(): FieldValue {
    return new FieldValue("FieldValue.delete");
  }

  static serverTimestamp(): FieldValue {
    return new FieldValue("FieldValue.serverTimestamp");
  }

  static arrayUnion<TArray extends unknown[]>(...elements: TArray): FieldValue<TArray> {
    return new FieldValue("FieldValue.arrayUnion", elements);
  }

  static arrayRemove<TArray extends unknown[]>(...elements: TArray): FieldValue<TArray> {
    return new FieldValue("FieldValue.arrayRemove", elements);
  }

  static increment(n: number = 1): FieldValue {
    return new FieldValue("FieldValue.increment", [n]);
  }
}
